import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import { motion } from "framer-motion";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { api } from "../lib/api";

export default function ArticlePage() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/articles/${id}`).then((r) => setArticle(r.data)).catch(() => setNotFound(true));
  }, [id]);

  return (
    <div data-testid="article-page">
      <Header />
      <main className="pt-32 pb-24 min-h-screen">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <Link to="/#learn" data-testid="article-back-link"
                className="inline-flex items-center gap-2 text-sm font-semibold text-stone-500 hover:text-ink transition-colors duration-300">
            <ArrowLeft size={16} /> Back to all articles
          </Link>
          {notFound && <p className="mt-16 font-serif text-2xl text-stone-500" data-testid="article-not-found">This article could not be found.</p>}
          {article && (
            <motion.article initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
              <div className="mt-10 flex items-center gap-3 text-[11px] font-mono uppercase tracking-[0.18em]">
                <span className="text-ember" data-testid="article-category">{article.category}</span>
                <span className="text-stone-400 flex items-center gap-1"><Clock size={12} /> {article.read_time}</span>
              </div>
              <h1 className="mt-4 font-serif font-bold tracking-tight text-ink text-4xl sm:text-5xl leading-[1.08]" data-testid="article-title">
                {article.title}
              </h1>
              <p className="mt-6 font-cormorant text-2xl text-stone-600 leading-relaxed" data-testid="article-excerpt">{article.excerpt}</p>
              {article.image_url && (
                <div className="mt-10 rounded-2xl overflow-hidden border border-linen">
                  <img src={article.image_url} alt="" className="w-full h-72 sm:h-96 object-cover" data-testid="article-image" />
                </div>
              )}
              <div className="mt-10 space-y-6" data-testid="article-body">
                {article.body.split(/\n\n+/).map((para, i) => (
                  <p key={i} className="text-base sm:text-lg text-stone-700 leading-relaxed">{para}</p>
                ))}
              </div>
              <div className="mt-14 rounded-2xl bg-ember-soft border border-linen p-8">
                <p className="font-serif text-xl text-ink leading-snug">Want more like this, plus free workshop invitations?</p>
                <a href="/#join" data-testid="article-join-link"
                   className="mt-4 inline-flex items-center rounded-full bg-ember text-cream text-sm font-semibold px-7 py-3.5 hover:bg-ember-dark transition-colors duration-300">
                  Join the community — free
                </a>
              </div>
            </motion.article>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
